import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from './source/appstates/appState';
import { LoginState } from './source/appstates/loginstates/loginState'; 

@Injectable({
  providedIn: 'root'
})
export class RouteauthGuard implements CanActivate, CanActivateChild, CanLoad {
  
  playerLoggedIn: boolean = false;
  
  constructor(private store: Store<AppState>, private router: Router) {
    // Subscribe to the login state directly in the constructor
    this.store.select("loginState").subscribe((loginState: LoginState) => {
      if (loginState.playerLoggedIn) {
        this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
      }
    });
  }

  // canActivate() is called before the route is activated
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Check if user is logged in
    if (this.playerLoggedIn) {
      return true;
    } else {
      // Redirect to home if not logged in
      this.router.navigate(['/home']);
      return false;
    }
  }

  // canActivateChild() is called for child routes
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    // Same logic as canActivate for child routes
    if (this.playerLoggedIn) {
      return true;
    } else {
      // this.router.navigate(['/home']);
      return false;
    }
  }

  // canLoad() is used for lazy-loaded routes
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    
    if (this.playerLoggedIn) {
      return true;
    } else {
      // this.router.navigate(['/home']);
      return false;
    }
  }
}
